import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { heroData } from '../data/mock';

const HeroSection = ({ onWaitlistClick }) => {
  return (
    <section className="min-h-screen flex items-center justify-center pt-20 pb-16 px-6 bg-gradient-to-b from-emerald-50/50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-8 animate-fade-in">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
            AI-Powered Creator Monetization
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-4 leading-tight">
            {heroData.headline}
            <span className="block text-emerald-600">{heroData.subheadline}</span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            {heroData.description}
          </p>

          {/* CTA */}
          <div className="flex items-center justify-center mb-16">
            <Button
              onClick={onWaitlistClick}
              size="lg"
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-6 rounded-full text-lg font-medium transition-all hover:shadow-xl hover:shadow-emerald-200 hover:-translate-y-0.5 group"
            >
              {heroData.ctaText}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
            {heroData.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-emerald-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-slate-500 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Visual Element */}
        <div className="mt-20 relative">
          <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent z-10"></div>
          <div className="bg-gradient-to-br from-slate-100 to-emerald-50 rounded-3xl p-8 md:p-12 shadow-2xl shadow-slate-200/50">
            <div className="grid grid-cols-3 gap-4">
              {/* Mockup cards */}
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 bg-emerald-100 rounded-xl mb-4"></div>
                <div className="h-3 bg-slate-200 rounded-full w-3/4 mb-2"></div>
                <div className="h-3 bg-slate-100 rounded-full w-1/2"></div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 bg-amber-100 rounded-xl mb-4"></div>
                <div className="h-3 bg-slate-200 rounded-full w-full mb-2"></div>
                <div className="h-3 bg-slate-100 rounded-full w-2/3"></div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 bg-teal-100 rounded-xl mb-4"></div>
                <div className="h-3 bg-slate-200 rounded-full w-5/6 mb-2"></div>
                <div className="h-3 bg-slate-100 rounded-full w-1/3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
